module.exports = __webpack_public_path__ + "8518d60f5980020483027c3bf2980903.png";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/PromotionBlock/images/promotion_image1.png
// module id = 1483
// module chunks = 3